import axiosInstance from "../axiosInstance";
import { apiEndpoints } from "../apiConfig";

const templateApi = {
  CustomEmailTemplate: (payload) =>
    axiosInstance.post(apiEndpoints.addCustomEmailTemplate, payload),
  getCustomEmailTemplate: () =>
    axiosInstance.get(apiEndpoints.addCustomEmailTemplate),
  editCustomEmailTemplate: (payload, customTemplateId) =>
    axiosInstance.post(
      apiEndpoints.editCustomEmailTemplate.replace("{id}", customTemplateId),
      payload
    ),
};

export default templateApi;
